// extracted by mini-css-extract-plugin
export default {"aiChatFooter":"sq83oQA04y0KKcNJfzHG","suggestionsContainer":"eB9DukkwLTrvlAb39Y39"};